import config from 'sites/enroll.pivothealth.com/start-application/config'
import controller from 'core/controllerPlans'
import once from 'utils/functional/once'
import updateDOM from './updateDOM'
import initDOM from './initDOM'
import finish from './finish'
import './styles.scss'

const registry = [once(initDOM), updateDOM, once(finish)]

controller(config, registry)
